import React from 'react'
import ReactDOM from 'react-dom'
import { CourseLoadingApp } from './App'

export let startCourseLoadingApp = (
  templateCoursenum,
  newCoursenum,
  instrId,
  targetUrl,
) => {
  ReactDOM.render(
    <CourseLoadingApp
      templateCoursenum={templateCoursenum}
      newCoursenum={newCoursenum}
      instrId={instrId}
      targetUrl={targetUrl}
    />,
    document.getElementById('app')
  )
}
